













import { computed, defineComponent } from '@nuxtjs/composition-api'

import SectionWithFooter from '../SectionWithFooter.vue'
import LiteHeader from '../LiteHeader.vue'
import Footer from '../Footer.vue'
import Protocol from './Protocol.vue'

import { MappedProduct } from '@/types/product/productTypes'

export default defineComponent({
  components: {
    LiteHeader,
    Protocol,
    SectionWithFooter,
    Footer,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
    size: {
      type: String as () => 'a4' | 'letter',
      required: true,
    },
  },
  setup(props) {
    const revision = computed(() => props.product.attributes.datasheetRevNo!)
    const protocols =
      props.product.attributes.lots?.lot.applications?.application
        ?.filter((application) => application.protocol && application.code !== 'E-P')
        .map((application) => props.product.attributes.protocols?.[application.protocol!.number].markup ?? '') ?? []

    // This is an edge case. When a protocol includes a table element, then during the print preview,
    // if this table spans multiple pages, its headers and footer will be shown/duplicated on every single
    // page that this table spans over. The `SectionWithFooter` component calculates the height of its content
    // and the number of pages its spans and places footer at the end of the last one.
    // This means that if any protocol contains a table, this calculated height is incorrect. Because of that
    // this approach cannot be used in this scenario.
    const includesTable = protocols.some((p) => p?.includes('</table>'))

    return {
      revision,
      protocols,
      includesTable,
    }
  },
})
